import React from "react";
import { HomeOutlined } from "@mui/icons-material";
import { useQuickLinksItems } from "../../../context/QuickLinksContext";

import {
  RootStack,
  HomeIconButton,
  BreadCrumbText,
  BreadCrumbItemText,
} from "./CustomBreadCrumb.styles";

const CustomBreadCrumb = ({ text, breadCrumb, breadCrumbOnClick }) => {
  const { setSelectedTab } = useQuickLinksItems();

  const handleBreadCrumbClick = () => {
    if (breadCrumb) {
      breadCrumbOnClick();
    }
  };

  return (
    <RootStack direction="row" spacing={1}>
      <HomeIconButton onClick={() => setSelectedTab("home")}>
        <HomeOutlined />
      </HomeIconButton>

      <BreadCrumbText>/</BreadCrumbText>

      <BreadCrumbText onClick={handleBreadCrumbClick}>{text}</BreadCrumbText>

      {breadCrumb && (
        <>
          <BreadCrumbText>/</BreadCrumbText>
          <BreadCrumbItemText>{breadCrumb}</BreadCrumbItemText>
        </>
      )}
    </RootStack>
  );
};

export default CustomBreadCrumb;
